import {
    urlNewsletter,
} from './Endpoints';
import AuthService from './AuthService';

class NewsletterService {
async request(endpoint, options = {}) {
        // Sin base no hay a donde llamar; mejor un error explicito que un fetch a
        // "undefinedconfig" que nginx responde con el index.html de la app.
        if (!urlNewsletter) {
            throw new Error('El modulo Newsletter no esta configurado (falta REACT_APP_NEWSLETTER_API_URL)');
        }
        const token = AuthService.getToken();
        const headers = { ...(options.headers || {}) };
        const isFormData = typeof FormData !== 'undefined' && options.body instanceof FormData;
        // Con FormData el navegador debe poner el boundary del multipart; si se
        // fija Content-Type a mano la peticion llega sin el archivo.
        if (!isFormData && !headers['Content-Type']) {
            headers['Content-Type'] = 'application/json';
        }
        if (token) {
            headers['Authorization'] = `Bearer ${token}`;
        }
    const response = await fetch(`${urlNewsletter}${endpoint}`, {
      method: options.method || 'GET',
      headers,
      body: options.body,
    });
    if (!response.ok) {
      throw new Error('Error de conexión con el servidor');
    }
    // for blob
    if (options.responseType === 'blob') {
      return response.blob();
    }
    let res;
    try {
      res = await response.json();
    } catch (e) {
      throw new Error('Respuesta no válida del servidor');
    }
    if (!res || res.status !== 'success') {
      const msg = (res && res.msg) ? res.msg : 'Ocurrió un error';
      const error = new Error(msg);
      error.status = res ? res.status : 'error';
      throw error;
    }
    return res;
  }


async getConfig() {
        return this.request('config');
    }

    async createConfig(data) {
        return this.request('config', { method: 'POST', body: JSON.stringify(data) });
    }

    async updateConfig(data) {
        return this.request('config', { method: 'PUT', body: JSON.stringify(data) });
    }

  async getChannels() {
    return this.request('channels');
  }

  async getMainCategories() {
    return this.request('main-categories');
  }

  async getCoverOptions() {
        return this.request('cover-options');
    }

    async uploadCover(file) {
    const form = new FormData();
    form.append('file', file);
    return this.request('upload-cover', { method: 'POST', headers: {}, body: form });
  }

  async previewList(data) {
    return this.request('novedades/preview-list', { method: 'POST', body: JSON.stringify(data) });
  }

  async previewPdf(data) {
    const blob = await this.request('novedades/preview', { method: 'POST', responseType: 'blob', body: JSON.stringify(data) });
    const url = window.URL.createObjectURL(blob);
    window.open(url);
    return true;
  }

  /**
   * Igual que previewPdf pero descargando el archivo en vez de abrirlo en otra
   * pestana. La URL de objeto se revoca al terminar: si no, el blob queda
   * retenido en memoria.
   */
  async downloadPreviewPdf(data, fileName) {
    const blob = await this.request('novedades/preview', { method: 'POST', responseType: 'blob', body: JSON.stringify(data) });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName || 'novedades.pdf';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
    return true;
  }

async sendNow() {
        return this.request('novedades/send', { method: 'POST' });
    }
}

const newsletterService = new NewsletterService();
export default newsletterService;
